<mat-toolbar class="editing-toolbar">
  <span>Editing: {{ category!.label }}</span>

  <span class="spacer"></span>

  <!-- TODO: Allow deleting a section -->
  <button mat-raised-button class="tools-button" (click)="saveForm()" [disabled]="saveButtonDisabled">
    <mat-icon svgIcon="content-save"></mat-icon>&nbsp;
    <span>Save</span>
  </button>
</mat-toolbar>

<form [formGroup]="categoryForm" class="dataset-form">

  <mat-form-field>
    <mat-label>Label</mat-label>
    <input matInput formControlName="label" placeholder="Label">
  </mat-form-field>

  <div class="slide-control">
    <mat-slide-toggle formControlName="sort_by_name"></mat-slide-toggle>
    <mat-label class="slide-label">Sort the datasets inside this category by name</mat-label>
  </div>

  <mat-form-field>
    <mat-label>Order in tree</mat-label>
    <input matInput type="number" formControlName="order" placeholder="Order in tree order">
  </mat-form-field>

  <div class="dataset-listing-tree">
    <mat-label>Parent category</mat-label>
    <div class="tree-node">
      <mat-radio-button [checked]="isRootChecked" (change)="selectionChanged($event)">
        <span class="name">
          No parent (root level)
        </span>
      </mat-radio-button>
    </div>

    <mood-select-category-tree-node *ngFor="let node of categoryTreeList" [node]="node"
      [selectedNode]="currentParentCategory" (selectedNodeChange)="updateParentCategory($event)"
      [nodeToDisable]="category.id"></mood-select-category-tree-node>
  </div>
</form>
